"use client";

import React from "react";
import StockChartLine from "@components/StockDetails/ChartLine";
import TokenChartLine from "@components/TokenDetails/ChartLine";
import { useStockDetailsMarket } from "@hooks/useStockDetailsMarket";
import { useTokenDetailsMarket } from "@hooks/useTokenDetailsMarket";
import {
  ViewDetailsLink,
  buildStockDetailHref,
  buildCryptoDetailHref,
} from "./ViewDetailsLink";

interface AssetPriceBusinessChartProps {
  assetType: "stock" | "crypto";
  assetRouterId: string;
}

export const AssetPriceBusinessChart: React.FC<
  AssetPriceBusinessChartProps
> = ({ assetType, assetRouterId }) => {
  const isStock = assetType === "stock";
  const isCrypto = assetType === "crypto";

  const { data: stockData, isLoading: stockLoading } = useStockDetailsMarket({
    enabled: isStock,
    queryParams: { ids: [assetRouterId] },
    queryKey: ["chat-price-resolve", assetRouterId],
  });

  const { data: tokenList, isLoading: tokenLoading } = useTokenDetailsMarket({
    enabled: isCrypto,
    ids: [assetRouterId],
    queryParams: { "enrich.with_market.enable": true },
  });

  const stockSymbol = stockData?.symbol || "";
  const tokenSymbol = (tokenList?.[0] as any)?.symbol || "";

  if (isCrypto) {
    if (tokenLoading || !tokenSymbol) {
      return (
        <div className="h-60 w-full animate-pulse bg-background_white_overlay5" />
      );
    }

    return (
      <>
        <div className="w-full overflow-hidden">
          <TokenChartLine id={assetRouterId} symbol={tokenSymbol} />
        </div>
        <ViewDetailsLink href={buildCryptoDetailHref(assetRouterId)} />
      </>
    );
  }

  if (stockLoading || !stockSymbol) {
    return (
      <div className="h-60 w-full animate-pulse bg-background_white_overlay5" />
    );
  }

  return (
    <>
      <div className="w-full overflow-hidden">
        <StockChartLine
          symbol={stockSymbol}
          short_name={stockData?.short_name || stockSymbol}
        />
      </div>
      <ViewDetailsLink href={buildStockDetailHref(stockSymbol)} />
    </>
  );
};
